import { createStore } from "solid-js/store";

import { getGetGameList } from "@/api/clientApi/home";
import { GameTag, GameTypeMap } from "@/enum/game";
import {
  GameNode,
  GetGameListReq,
  GetGameListRsp,
} from "@/types/swagger/front.ts";

interface menuStoreType {
  recentGameList: number[]; // 最近游戏
  collectGameList: number[]; // 收藏游戏
  gameList: GameNode[];
  finish: boolean;
  loading: boolean;
  apiLoading: boolean; // 是否正在加载
  shareLink: string;
  params: GetGameListReq;
}
const [menuStore, setMenuStoreStore] = createStore<menuStoreType>({
  recentGameList: [],
  collectGameList: [],
  gameList: [],
  finish: false,
  loading: false,
  apiLoading: true,
  shareLink: "",
  params: {
    page: "1",
    page_size: "40",
    name: "",
    sort: "0",
    maker_tag: "",
  },
});
interface GameListQuery {
  tag?: GameTag;
  type?: GameTypeMap;
  isSearch?: boolean;
  ids?: string;
}

// 获取游戏列表
const loadGameList = async (query: GameListQuery, isFrist?: boolean) => {
  if (menuStore.loading || menuStore.finish) return;
  try {
    setMenuStoreStore("loading", true);
    setMenuStoreStore("apiLoading", true);
    const res: GetGameListRsp = await getGetGameList({
      ...menuStore.params,
      ...query,
    });
    setMenuStoreStore(
      "gameList",
      isFrist ? res.list : [...menuStore.gameList, ...res.list],
    );
    setMenuStoreStore("apiLoading", false);
    if (
      Number(menuStore.params.page) * Number(menuStore.params.page_size) >=
      (res.total ? res.total : Number(menuStore.params.page_size))
    ) {
      setMenuStoreStore("finish", true);
    } else {
      setMenuStoreStore(
        "params",
        "page",
        String(Number(menuStore.params.page) + 1),
      );
    }
  } finally {
    setMenuStoreStore("loading", false);
    setMenuStoreStore("apiLoading", false);
  }
};
const initGameInfo = () => {
  setMenuStoreStore("gameList", []);
  setMenuStoreStore("finish", false);
  setMenuStoreStore("loading", false);
  setMenuStoreStore("apiLoading", true);
  setMenuStoreStore("params", {
    page: "1",
    page_size: "40",
    name: "",
    sort: "0",
    maker_tag: "",
  });
};
export { menuStore, setMenuStoreStore, initGameInfo, loadGameList };
